<script setup>
import { useI18n } from "vue-i18n";

import dealershipIcon from '@/assets/icons/dealership-icon.svg'
import serviceCenterIcon from '@/assets/icons/service-center-icon.svg'
import mobileMechanicIcon from '@/assets/icons/mobile-mechanic-icon.svg'

const props = defineProps({
    serviceProvider: {
        type: Object,
        required: true
    }
})

// I18n
const { t } = useI18n();

</script>

<template>
    <div>
        <div class="flex min-w-fit items-center" v-if="serviceProvider.is_dealership">
            <img class="h-4 md:h-6 pl-2" :src="dealershipIcon" alt="" />
            <p class="ml-2 uppercase">{{ t('service_providers.search_filters.service_chain_dealership') }}</p>
        </div>

        <div class="flex min-w-fit items-center" v-if="serviceProvider.is_chain">
            <img class="h-4 md:h-6 pl-2" :src="serviceCenterIcon" alt="" />
            <p class="ml-2 uppercase">{{ t('service_providers.search_filters.service_chain_chain') }}</p>
        </div>

        <div class="flex min-w-fit items-center" v-if="serviceProvider.is_independent">
            <img class="h-4 md:h-6 pl-2" :src="mobileMechanicIcon" alt="" />
            <p class="ml-2 uppercase">{{ t('service_providers.search_filters.service_chain_independent') }}</p>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>
